import axios from 'axios';
import API from 'intakeOptimization/api/legacy/config';

export const getEmergencyContactInfo = (accountHolderId) => API.get(`/patients/emergency_contact/${accountHolderId}`);

export const getPatientInfo = (token) => axios.get(`/api/v1/patient_info?token=${token}`);

export const getInsuranceList = ({ zipCode, typeOfCare, appName = 'obie' }) => API.get(`/insurances?zip_code=${zipCode}&type_of_care=${typeOfCare}&app_name=${appName}`);
